import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import 'assets/scss/index.scss'
import App from './App'
import * as serviceWorker from './serviceWorker'
import './dotenv.validator'
import StateProviders from './lib/StateProviders'
import 'i18n'

require('dotenv').config()

// eslint-disable-next-line no-undef
ReactDOM.render(
  <StateProviders>
    <App />
  </StateProviders>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
